import { PriceLevel, Promotion } from "webshop-api";
import { PriceLevelState } from "@/domain/ticket-selection";
import { PromotionHoldStateMapper } from "@/domain/ticket-selection/entities/promotion-hold/PromotionHoldState.mapper";


/**
 * PriceLevelStateMapper
 */
export class PriceLevelStateMapper {

    /**
     * whatItDoes
     * maps PriceLevel entity to PriceLevelState
     */
    public static fromPriceLevel(
        object: PriceLevel,
        index: number,
        array: PriceLevel[],
        applicationTicketMaximum: number,
        promotionList: Array<Promotion>
    ): PriceLevelState {
        return {
            active: array.length === 1,
            alwaysOpen: array.length === 1,
            canSubmit: false,
            currency: object.currency!,
            number: object.number!,
            open: array.length === 1,
            priceLevelId: object.priceLevelId!,
            promotionHolds: object.promotionHolds
                ? object.promotionHolds.map(entity => PromotionHoldStateMapper.fromPromotionHold(
                    entity,
                    applicationTicketMaximum,
                    promotionList
                ))
                : [],
            text: object.text && object.text!.length < 45 ? object.text : `PK ${object.number}`,
            description: this.getDescription(object)
        };
    }

    /**
     * whatItDoes
     * builds PriceLevel description content
     */
    private static getDescription(data: PriceLevel): string | null {
        let description = '';

        if (data.description) {
            description = data.description;
        }

        if (data.text && data.text!.length >= 45) {
            description = description + '\n\n' + data.text;
        }

        return description.length === 0 ? null : description;
    }

}
